import PropTypes from 'prop-types';
import { Heading, Stack } from '@/components/ui/index.js';
import styles from './SettingsSection.module.css';

/**
 * SettingsSection - Groups related settings with a header
 * Used to organize settings into logical sections
 */
export function SettingsSection({
  title,
  children,
  variant = 'default',
  className = '',
  ...props
}) {
  const classNames = [
    styles.section,
    styles[variant],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classNames} {...props}>
      <Heading 
        level={3} 
        size="sm" 
        color={variant === 'danger' ? 'error' : 'muted'}
        transform="uppercase"
        className={styles.title}
      >
        {title}
      </Heading>
      <Stack direction="column" gap={0} className={styles.content}>
        {children}
      </Stack>
    </section>
  );
}

SettingsSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'danger']),
  className: PropTypes.string,
};

export default SettingsSection;
